module.exports = __webpack_public_path__ + "assets/8249ff207d9901bce9cfb72d6c0ba9a3.mp3";